var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-back",on:{"click":_vm.$_hamburgerBackClick}},[_vm._v("\n      "+_vm._s(_vm.$t('closeLabel'))+"\n  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }